import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledBackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  color: inherit;
  text-decoration: none !important;

  &:is(:hover, :focus, :active) {
    color: ${({ theme }) => theme?.token?.colorPrimary};
  }
`;
